// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Map_wrapper__O3df2","detailsCard":"Map_detailsCard__lZoeB"};